import { TAppState } from '../../types/appState';

export const contextTokenSelector = (state: TAppState) => state.contextToken;
